import React from 'react';
import Breadcrumbs from "../components/Breadcrumbs";
import Gallery from "../components/Gallery";
import {Helmet} from "react-helmet";

const Photo = () => {
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Фото - Holz-City</title>
                <meta
                    name="description"
                    content="Высококачественные пиломатериалы для строительства, отделки и ремонта."
                />
            </Helmet>
            <Breadcrumbs/>
            <Gallery/>
        </div>
    );
};

export default Photo;